var PRICE_API_URL = 'https://php.shopcode.cz/api/outdoormarket/api-prices.php'; // ← uprav cestu dle potřeby
function mhPriceFetch() {
    var skuMap = {};
    $('.product').each(function () {
        var $product = $(this);
        var sku = $product.find('[data-micro="sku"]').text().trim();
        if (sku) {
            skuMap[sku] = $product;
        }
    });
    var codes = Object.keys(skuMap);
    if (codes.length === 0) return;
    $.ajax({
        url:         PRICE_API_URL,
        method:      'POST',
        contentType: 'application/json',
        dataType:    'json',
        data:        JSON.stringify({ codes: codes }),
    })
    .done(function (response) {
        if (response.status !== 'ok') return;
        $.each(response.data, function (i, item) {
            var $product = skuMap[item.item_id];
            if (!$product) return;
            var $priceEl = $product.find('.price-final strong');
            if ($priceEl.length) {
                $priceEl.attr('data-lower-price', Number(item.common_price).ShoptetFormatAsCurrency());
            }
        });
    })
    .fail(function (xhr, status, error) {
        console.error('[mhPriceFetch] AJAX chyba: ' + status + ' – ' + error);
    });
}

$(document).ready(function () {
    mhPriceFetch();
});
document.addEventListener('ShoptetDOMContentLoaded', function () {
    mhPriceFetch();
});
document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    mhPriceFetch();
});
document.addEventListener('ShoptetPageSortingChanged', function () {
    mhPriceFetch();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    mhPriceFetch();
});

document.addEventListener('saimonProductsWidgetLoaded', function () {
    mhPriceFetch();
});

